import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../services/api";
import SpecialtyCakesTable from "./SpecialtyCakesTable";
import SpecialtyCakeFormDrawer from "./SpecialtyCakeFormDrawer";

const SpecialtyCakesPage = () => {
  const [cakes, setCakes] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedCake, setSelectedCake] = useState(null);

  useEffect(() => {
    fetchCakes();
  }, []);

  const fetchCakes = async () => {
    try {
      const response = await api.get("/specialty-cakes");
      setCakes(response.data);
    } catch (error) {
      console.error("Error fetching cakes:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/specialty-cakes/${id}`);
      fetchCakes();
    } catch (error) {
      console.error("Error deleting cake:", error);
    }
  };

  const handleEdit = (cake) => {
    setSelectedCake(cake);
    setDrawerOpen(true);
  };

  const handleAdd = () => {
    setSelectedCake(null);
    setDrawerOpen(true);
  };

  return (
    <Box>
      {/* Top Heading + Add Button */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}>
        <Typography variant="h4" fontWeight={700}>
          Manage Specialty Cakes
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />} // ✨ plus icon
          onClick={handleAdd}
          sx={{ textTransform: "none", fontWeight: 600 }}>
          Add Cake
        </Button>
      </Box>

      {/* Table */}
      <SpecialtyCakesTable
        cakes={cakes}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      {/* Drawer */}
      <SpecialtyCakeFormDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onSave={fetchCakes}
        cakeData={selectedCake}
      />
    </Box>
  );
};

export default SpecialtyCakesPage;
